import React from 'react';
import { PaymentMethodType, TermPaymentTypes } from '@css-xp/graphtypes/src/generated-types-new';
import { PageTabs } from '@css-xp/base';
import { TermDetailsAssociatedAccountsTab } from './term-details-associated-accounts-tab/term-details-associated-accounts-tab';
import { TermDetailsAuditTrailTab } from './term-details-audit-trails-tab';
import { FilteredInvoiceTable } from '../../index';
import { generatedTypesNew } from '@css-xp/graphtypes';

interface Props {
  transactionAccount: generatedTypesNew.TransactionAccount | undefined;
  isLoading: boolean;
}

export const TermDetailsTab: React.FC<Props> = ({ isLoading, transactionAccount }) => {
  const associatedAccounts = transactionAccount?.billingAccountsList;
  const id = transactionAccount?.id ? transactionAccount.id : '';
  const taxId = transactionAccount?.billToParty?.taxId;
  const termType = transactionAccount?.billingAccountsList?.paymentMethod
    ? (transactionAccount?.billingAccountsList?.paymentMethod as TermPaymentTypes)
    : TermPaymentTypes.NET14;
  const transactionAccountNumber = transactionAccount?.transactionAccountNumber
    ? transactionAccount.transactionAccountNumber
    : '';
  const deferredPaymentMethod =
    transactionAccount?.availablePaymentMethods?.nodes?.filter(
      (paymentMethod) => paymentMethod?.type === PaymentMethodType.DEFERRED
    ) ?? [];
  return termType === TermPaymentTypes.NET30 ? (
    <PageTabs>
      <FilteredInvoiceTable
        transactionAccountId={id}
        transactionNumber={transactionAccountNumber}
        pushPaymentMethodId={deferredPaymentMethod[0]?.id as string}
        label="Invoices"
      />
      <TermDetailsAssociatedAccountsTab
        label="Associated billing accounts"
        isLoading={isLoading}
        associatedAccounts={associatedAccounts}
      />
      <TermDetailsAuditTrailTab label="Audit trail" id={id} taxId={taxId} netTerm={termType} />
    </PageTabs>
  ) : (
    <PageTabs>
      <FilteredInvoiceTable
        transactionAccountId={id}
        transactionNumber={transactionAccountNumber}
        pushPaymentMethodId={deferredPaymentMethod[0]?.id as string}
        label="Invoices"
      />
      <TermDetailsAuditTrailTab label="Audit trail" id={id} taxId={taxId} netTerm={termType} />
    </PageTabs>
  );
};

export default TermDetailsTab;
